import { FilterCriteriaType, FilterValue, GridFilters } from "./gridTypes";

export function setFilterPropertyHandler(prevState: GridFilters, filterType: FilterCriteriaType, value: FilterValue): GridFilters {
    const currentFilterValue = prevState[filterType];
    if (Array.isArray(currentFilterValue)) {
        let updatedValue: number[];
        if (currentFilterValue.includes(value as number)) {
        updatedValue = currentFilterValue.filter((currentValue) => currentValue !== value);
        } else {
        updatedValue = [...currentFilterValue, value as number];
        }
        const newFilter =  {[filterType]: updatedValue}
        return {...prevState, ...newFilter}
    } else {
        const newFilter = { [filterType]: value };
        return {...prevState, ...newFilter}
    }
};